import React from "react";
import { Button } from "react-bootstrap";
import { BiArrowBack } from "react-icons/bi";

function BackButton() {
  const handleBack = () => {
    window.history.go(-1);
  };

  return (
    <Button onClick={handleBack}><BiArrowBack/></Button>
  );
}

export default BackButton;
